var map = {
	"./forecast/spi3/spi3_20220516_01_00.tif": 99486,
	"./forecast/spi3/spi3_20220517_01_00.tif": 45109,
	"./forecast/spi3/spi3_20220518_01_00.tif": 19345,
	"./forecast/spi3/spi3_20220519_01_00.tif": 598,
	"./forecast/spi3/spi3_20220520_01_00.tif": 79269,
	"./forecast/spi3/spi3_20220521_01_00.tif": 94512,
	"./forecast/spi3/spi3_20220522_01_00.tif": 3458,
	"./forecast/spi3/spi3_20220523_01_00.tif": 71540,
	"./forecast/spi3/spi3_20220524_01_00.tif": 85926,
	"./forecast/spi3/spi3_20220525_01_00.tif": 63182,
	"./forecast/spi3/spi3_20220526_01_00.tif": 87499,
	"./forecast/spi3/spi3_20220527_01_00.tif": 291,
	"./forecast/spi3/spi3_20220528_01_00.tif": 44300,
	"./forecast/spi3/spi3_20220529_01_00.tif": 99187,
	"./forecast/spi3/spi3_20220530_01_00.tif": 66423,
	"./forecast/spi3/spi3_20220531_01_00.tif": 5367,
	"./forecast/spi3/spi3_20220601_01_00.tif": 17889,
	"./forecast/spi3/spi3_20220602_01_00.tif": 75490,
	"./forecast/spi3/spi3_20220603_01_00.tif": 63694,
	"./forecast/spi3/spi3_20220604_01_00.tif": 27979,
	"./forecast/spi3/spi3_20220605_01_00.tif": 48362,
	"./forecast/spi3/spi3_20220606_01_00.tif": 30647,
	"./forecast/spi3/spi3_20220607_01_00.tif": 32481,
	"./forecast/spi3/spi3_20220608_01_00.tif": 82189,
	"./forecast/spi3/spi3_20220609_01_00.tif": 68670,
	"./forecast/spi3/spi3_20220610_01_00.tif": 64621,
	"./forecast/spi3/spi3_20220611_01_00.tif": 91411,
	"./forecast/spi3/spi3_20220612_01_00.tif": 43847,
	"./forecast/spi3/spi3_20220613_01_00.tif": 66559,
	"./forecast/spi3/spi3_20220614_01_00.tif": 84379,
	"./forecast/spi3/spi3_20220615_01_00.tif": 6169,
	"./forecast/spi3/spi3_20220616_01_00.tif": 60904,
	"./forecast/spi3/spi3_20220617_01_00.tif": 44652,
	"./forecast/spi3/spi3_20220618_01_00.tif": 29024,
	"./forecast/spi3/spi3_20220619_01_00.tif": 62248,
	"./forecast/spi3/spi3_20220620_01_00.tif": 28674,
	"./forecast/spi3/spi3_20220621_01_00.tif": 45782,
	"./forecast/spi3/spi3_20220622_01_00.tif": 43806,
	"./forecast/spi3/spi3_20220623_01_00.tif": 64754,
	"./forecast/spi3/spi3_20220624_01_00.tif": 33738,
	"./forecast/spi3/spi3_20220625_01_00.tif": 44891,
	"./forecast/spi3/spi3_20220626_01_00.tif": 28895,
	"./forecast/spi3/spi3_20220627_01_00.tif": 30698,
	"./forecast/spi3/spi3_20220628_01_00.tif": 56237,
	"./forecast/spi3/spi3_20220629_01_00.tif": 29175,
	"./forecast/spi3/spi3_20220630_01_00.tif": 79210,
	"./forecast/spi3/spi3_20220701_01_00.tif": 90605,
	"./forecast/spi3/spi3_20220702_01_00.tif": 19160,
	"./forecast/spi3/spi3_20220703_01_00.tif": 49291,
	"./forecast/spi3/spi3_20220704_01_00.tif": 884,
	"./forecast/spi3/spi3_20220705_01_00.tif": 87208,
	"./forecast/spi3/spi3_20220706_01_00.tif": 31017,
	"./forecast/spi3/spi3_20220707_01_00.tif": 21829,
	"./forecast/spi3/spi3_20220708_01_00.tif": 87084,
	"./forecast/spi3/spi3_20220709_01_00.tif": 6387,
	"./forecast/spi3/spi3_20220710_01_00.tif": 72665,
	"./forecast/spi3/spi3_20220711_01_00.tif": 19277,
	"./forecast/spi3/spi3_20220712_01_00.tif": 66187,
	"./forecast/spi3/spi3_20220713_01_00.tif": 82606,
	"./forecast/spi3/spi3_20220714_01_00.tif": 80941,
	"./forecast/spi3/spi3_20220715_01_00.tif": 6931,
	"./forecast/spi3/spi3_20220716_01_00.tif": 86385,
	"./forecast/spi3/spi3_20220717_01_00.tif": 97127,
	"./forecast/spi3/spi3_20220718_01_00.tif": 9609,
	"./forecast/spi3/spi3_20220719_01_00.tif": 9573,
	"./forecast/spi3/spi3_20220720_01_00.tif": 43512,
	"./forecast/spi3/spi3_20220721_01_00.tif": 24588,
	"./forecast/spi3/spi3_20220722_01_00.tif": 83544,
	"./forecast/spi3/spi3_20220723_01_00.tif": 22709,
	"./forecast/spi3/spi3_20220724_01_00.tif": 55643,
	"./forecast/spi3/spi3_20220725_01_00.tif": 50458,
	"./forecast/spi3/spi3_20220726_01_00.tif": 51217,
	"./forecast/spi3/spi3_20220727_01_00.tif": 72,
	"./forecast/spi3/spi3_20220728_01_00.tif": 45317,
	"./forecast/spi3/spi3_20220729_01_00.tif": 83149,
	"./forecast/spi3/spi3_20220730_01_00.tif": 41570,
	"./forecast/spi3/spi3_20220731_01_00.tif": 3393,
	"./forecast/spi3/spi3_20220801_01_00.tif": 95780,
	"./forecast/spi3/spi3_20220802_01_00.tif": 31676,
	"./forecast/spi3/spi3_20220803_01_00.tif": 28642,
	"./forecast/spi3/spi3_20220804_01_00.tif": 56718,
	"./forecast/spi3/spi3_20220805_01_00.tif": 89864,
	"./forecast/spi3/spi3_20220806_01_00.tif": 92575,
	"./forecast/spi3/spi3_20220807_01_00.tif": 7007,
	"./forecast/spi3/spi3_20220808_01_00.tif": 77744,
	"./forecast/spi3/spi3_20220809_01_00.tif": 92196,
	"./forecast/spi3/spi3_20220810_01_00.tif": 50916,
	"./forecast/spi3/spi3_20220811_01_00.tif": 2083,
	"./forecast/spi3/spi3_20220812_01_00.tif": 81676,
	"./forecast/spi3/spi3_20220813_01_00.tif": 69822,
	"./forecast/spi3/spi3_20220814_01_00.tif": 17405,
	"./forecast/spi3/spi3_20220815_01_00.tif": 57340,
	"./forecast/spi3/spi3_20220816_01_00.tif": 62196,
	"./forecast/spi3/spi3_20220817_01_00.tif": 89252,
	"./forecast/spi3/spi3_20220818_01_00.tif": 89699,
	"./forecast/spi3/spi3_20220819_01_00.tif": 74019,
	"./forecast/spi3/spi3_20220820_01_00.tif": 86800,
	"./forecast/spi3/spi3_20220821_01_00.tif": 98925,
	"./forecast/spi3/spi3_20220822_01_00.tif": 81729,
	"./forecast/spi3/spi3_20220823_01_00.tif": 5997,
	"./forecast/spi3/spi3_20220824_01_00.tif": 99966,
	"./forecast/spi3/spi3_20220825_01_00.tif": 35607,
	"./forecast/spi3/spi3_20220826_01_00.tif": 46283,
	"./forecast/spi3/spi3_20220827_01_00.tif": 64119,
	"./forecast/spi3/spi3_20220828_01_00.tif": 81702,
	"./forecast/spi3/spi3_20220829_01_00.tif": 96122,
	"./forecast/spi3/spi3_20220830_01_00.tif": 93329,
	"./forecast/spi3/spi3_20220831_01_00.tif": 11734,
	"./forecast/spi3/spi3_20220901_01_00.tif": 6413,
	"./forecast/spi3/spi3_20220902_01_00.tif": 66634,
	"./forecast/spi3/spi3_20220903_01_00.tif": 42932,
	"./forecast/spi3/spi3_20220904_01_00.tif": 49873,
	"./forecast/spi3/spi3_20220905_01_00.tif": 58237,
	"./forecast/spi3/spi3_20220906_01_00.tif": 62172,
	"./forecast/spi3/spi3_20220907_01_00.tif": 47151,
	"./forecast/spi3/spi3_20220908_01_00.tif": 61339,
	"./forecast/spi3/spi3_20220909_01_00.tif": 33355,
	"./forecast/spi3/spi3_20220910_01_00.tif": 33328,
	"./forecast/spi3/spi3_20220911_01_00.tif": 60413,
	"./forecast/spi3/spi3_20220912_01_00.tif": 13219,
	"./forecast/spi3/spi3_20220913_01_00.tif": 97064,
	"./forecast/spi3/spi3_20220914_01_00.tif": 15361,
	"./forecast/spi3/spi3_20220915_01_00.tif": 97131,
	"./forecast/spi3/spi3_20220916_01_00.tif": 9155,
	"./forecast/spi3/spi3_20220917_01_00.tif": 25796,
	"./forecast/spi3/spi3_20220918_01_00.tif": 23236,
	"./forecast/spi3/spi3_20220919_01_00.tif": 25419,
	"./forecast/spi3/spi3_20220920_01_00.tif": 56347,
	"./forecast/spi3/spi3_20220921_01_00.tif": 81183,
	"./forecast/spi3/spi3_20220922_01_00.tif": 21677,
	"./forecast/spi3/spi3_20220923_01_00.tif": 68408,
	"./forecast/spi3/spi3_20220924_01_00.tif": 57873,
	"./forecast/spi3/spi3_20220925_01_00.tif": 25397,
	"./forecast/spi3/spi3_20220926_01_00.tif": 56902,
	"./forecast/spi3/spi3_20220927_01_00.tif": 74241,
	"./forecast/spi3/spi3_20220928_01_00.tif": 28548,
	"./forecast/spi3/spi3_20220929_01_00.tif": 4223,
	"./forecast/spi3/spi3_20220930_01_00.tif": 50253,
	"./nowcast/spi3/spi3_20210515_01_00.tif": 74441,
	"./nowcast/spi3/spi3_20210516_01_00.tif": 23905,
	"./nowcast/spi3/spi3_20210517_01_00.tif": 10167,
	"./nowcast/spi3/spi3_20210518_01_00.tif": 56807,
	"./nowcast/spi3/spi3_20210519_01_00.tif": 13986,
	"./nowcast/spi3/spi3_20210520_01_00.tif": 18163,
	"./nowcast/spi3/spi3_20210521_01_00.tif": 55738,
	"./nowcast/spi3/spi3_20210522_01_00.tif": 92730,
	"./nowcast/spi3/spi3_20210523_01_00.tif": 90386,
	"./nowcast/spi3/spi3_20210524_01_00.tif": 66302,
	"./nowcast/spi3/spi3_20210525_01_00.tif": 42715,
	"./nowcast/spi3/spi3_20210526_01_00.tif": 9686,
	"./nowcast/spi3/spi3_20210527_01_00.tif": 94906,
	"./nowcast/spi3/spi3_20210528_01_00.tif": 9382,
	"./nowcast/spi3/spi3_20210529_01_00.tif": 24342,
	"./nowcast/spi3/spi3_20210530_01_00.tif": 28005,
	"./nowcast/spi3/spi3_20210531_01_00.tif": 34943,
	"./nowcast/spi3/spi3_20210601_01_00.tif": 34201,
	"./nowcast/spi3/spi3_20210602_01_00.tif": 64035,
	"./nowcast/spi3/spi3_20210603_01_00.tif": 13891,
	"./nowcast/spi3/spi3_20210604_01_00.tif": 24376,
	"./nowcast/spi3/spi3_20210605_01_00.tif": 95510,
	"./nowcast/spi3/spi3_20210606_01_00.tif": 96813,
	"./nowcast/spi3/spi3_20210607_01_00.tif": 41855,
	"./nowcast/spi3/spi3_20210608_01_00.tif": 63050,
	"./nowcast/spi3/spi3_20210609_01_00.tif": 21704,
	"./nowcast/spi3/spi3_20210610_01_00.tif": 33649,
	"./nowcast/spi3/spi3_20210611_01_00.tif": 3294,
	"./nowcast/spi3/spi3_20210612_01_00.tif": 55649,
	"./nowcast/spi3/spi3_20210613_01_00.tif": 21491,
	"./nowcast/spi3/spi3_20210614_01_00.tif": 36214,
	"./nowcast/spi3/spi3_20210615_01_00.tif": 58294,
	"./nowcast/spi3/spi3_20210616_01_00.tif": 17238,
	"./nowcast/spi3/spi3_20210617_01_00.tif": 52756,
	"./nowcast/spi3/spi3_20210618_01_00.tif": 89445,
	"./nowcast/spi3/spi3_20210619_01_00.tif": 35377,
	"./nowcast/spi3/spi3_20210620_01_00.tif": 4953,
	"./nowcast/spi3/spi3_20210621_01_00.tif": 19854,
	"./nowcast/spi3/spi3_20210622_01_00.tif": 99914,
	"./nowcast/spi3/spi3_20210623_01_00.tif": 30496,
	"./nowcast/spi3/spi3_20210624_01_00.tif": 5607,
	"./nowcast/spi3/spi3_20210625_01_00.tif": 15214,
	"./nowcast/spi3/spi3_20210626_01_00.tif": 60036,
	"./nowcast/spi3/spi3_20210627_01_00.tif": 49722,
	"./nowcast/spi3/spi3_20210628_01_00.tif": 68991,
	"./nowcast/spi3/spi3_20210629_01_00.tif": 50912,
	"./nowcast/spi3/spi3_20210630_01_00.tif": 62356,
	"./nowcast/spi3/spi3_20210701_01_00.tif": 92381,
	"./nowcast/spi3/spi3_20210702_01_00.tif": 66975,
	"./nowcast/spi3/spi3_20210703_01_00.tif": 14122,
	"./nowcast/spi3/spi3_20210704_01_00.tif": 86252,
	"./nowcast/spi3/spi3_20210705_01_00.tif": 19993,
	"./nowcast/spi3/spi3_20210706_01_00.tif": 63810,
	"./nowcast/spi3/spi3_20210707_01_00.tif": 96484,
	"./nowcast/spi3/spi3_20210708_01_00.tif": 44703,
	"./nowcast/spi3/spi3_20210709_01_00.tif": 60045,
	"./nowcast/spi3/spi3_20210710_01_00.tif": 65670,
	"./nowcast/spi3/spi3_20210711_01_00.tif": 89449,
	"./nowcast/spi3/spi3_20210712_01_00.tif": 45723,
	"./nowcast/spi3/spi3_20210713_01_00.tif": 32862,
	"./nowcast/spi3/spi3_20210714_01_00.tif": 62948,
	"./nowcast/spi3/spi3_20210715_01_00.tif": 59588,
	"./nowcast/spi3/spi3_20210716_01_00.tif": 5029,
	"./nowcast/spi3/spi3_20210717_01_00.tif": 35849,
	"./nowcast/spi3/spi3_20210718_01_00.tif": 27146,
	"./nowcast/spi3/spi3_20210719_01_00.tif": 7913,
	"./nowcast/spi3/spi3_20210720_01_00.tif": 23664,
	"./nowcast/spi3/spi3_20210721_01_00.tif": 20150,
	"./nowcast/spi3/spi3_20210722_01_00.tif": 73406,
	"./nowcast/spi3/spi3_20210723_01_00.tif": 35189,
	"./nowcast/spi3/spi3_20210724_01_00.tif": 6176,
	"./nowcast/spi3/spi3_20210725_01_00.tif": 38051,
	"./nowcast/spi3/spi3_20210726_01_00.tif": 3732,
	"./nowcast/spi3/spi3_20210727_01_00.tif": 47253,
	"./nowcast/spi3/spi3_20210728_01_00.tif": 20274,
	"./nowcast/spi3/spi3_20210729_01_00.tif": 18843,
	"./nowcast/spi3/spi3_20210730_01_00.tif": 85091,
	"./nowcast/spi3/spi3_20210731_01_00.tif": 778,
	"./nowcast/spi3/spi3_20210801_01_00.tif": 42267,
	"./nowcast/spi3/spi3_20210802_01_00.tif": 67769,
	"./nowcast/spi3/spi3_20210803_01_00.tif": 62207,
	"./nowcast/spi3/spi3_20210804_01_00.tif": 88552,
	"./nowcast/spi3/spi3_20210805_01_00.tif": 42419,
	"./nowcast/spi3/spi3_20210806_01_00.tif": 567,
	"./nowcast/spi3/spi3_20210807_01_00.tif": 3724,
	"./nowcast/spi3/spi3_20210808_01_00.tif": 73960,
	"./nowcast/spi3/spi3_20210809_01_00.tif": 99765,
	"./nowcast/spi3/spi3_20210810_01_00.tif": 37973,
	"./nowcast/spi3/spi3_20210811_01_00.tif": 77769,
	"./nowcast/spi3/spi3_20210812_01_00.tif": 28116,
	"./nowcast/spi3/spi3_20210813_01_00.tif": 3758,
	"./nowcast/spi3/spi3_20210814_01_00.tif": 45444,
	"./nowcast/spi3/spi3_20210815_01_00.tif": 93416,
	"./nowcast/spi3/spi3_20210816_01_00.tif": 76200,
	"./nowcast/spi3/spi3_20210817_01_00.tif": 82386,
	"./nowcast/spi3/spi3_20210818_01_00.tif": 39532,
	"./nowcast/spi3/spi3_20210819_01_00.tif": 49657,
	"./nowcast/spi3/spi3_20210820_01_00.tif": 61956,
	"./nowcast/spi3/spi3_20210821_01_00.tif": 87567,
	"./nowcast/spi3/spi3_20210822_01_00.tif": 28400,
	"./nowcast/spi3/spi3_20210823_01_00.tif": 98819,
	"./nowcast/spi3/spi3_20210824_01_00.tif": 37791,
	"./nowcast/spi3/spi3_20210825_01_00.tif": 90051,
	"./nowcast/spi3/spi3_20210826_01_00.tif": 28470,
	"./nowcast/spi3/spi3_20210827_01_00.tif": 79057,
	"./nowcast/spi3/spi3_20210828_01_00.tif": 17042,
	"./nowcast/spi3/spi3_20210829_01_00.tif": 7290,
	"./nowcast/spi3/spi3_20210830_01_00.tif": 10427,
	"./nowcast/spi3/spi3_20210831_01_00.tif": 61669,
	"./nowcast/spi3/spi3_20210901_01_00.tif": 70589,
	"./nowcast/spi3/spi3_20210902_01_00.tif": 37082,
	"./nowcast/spi3/spi3_20210903_01_00.tif": 5150,
	"./nowcast/spi3/spi3_20210904_01_00.tif": 52480,
	"./nowcast/spi3/spi3_20210905_01_00.tif": 91997,
	"./nowcast/spi3/spi3_20210906_01_00.tif": 30137,
	"./nowcast/spi3/spi3_20210907_01_00.tif": 3163,
	"./nowcast/spi3/spi3_20210908_01_00.tif": 65755,
	"./nowcast/spi3/spi3_20210909_01_00.tif": 58173,
	"./nowcast/spi3/spi3_20210910_01_00.tif": 48278,
	"./nowcast/spi3/spi3_20210911_01_00.tif": 79138,
	"./nowcast/spi3/spi3_20210912_01_00.tif": 49607,
	"./nowcast/spi3/spi3_20210913_01_00.tif": 42412,
	"./nowcast/spi3/spi3_20210914_01_00.tif": 25137,
	"./nowcast/spi3/spi3_20210915_01_00.tif": 85221,
	"./nowcast/spi3/spi3_20210916_01_00.tif": 71037,
	"./nowcast/spi3/spi3_20210917_01_00.tif": 13803,
	"./nowcast/spi3/spi3_20210918_01_00.tif": 75853,
	"./nowcast/spi3/spi3_20210919_01_00.tif": 9910,
	"./nowcast/spi3/spi3_20210920_01_00.tif": 11276,
	"./nowcast/spi3/spi3_20210921_01_00.tif": 52063,
	"./nowcast/spi3/spi3_20210922_01_00.tif": 59634,
	"./nowcast/spi3/spi3_20210923_01_00.tif": 3107,
	"./nowcast/spi3/spi3_20210924_01_00.tif": 73470,
	"./nowcast/spi3/spi3_20210925_01_00.tif": 27361,
	"./nowcast/spi3/spi3_20210926_01_00.tif": 31506,
	"./nowcast/spi3/spi3_20210927_01_00.tif": 59208,
	"./nowcast/spi3/spi3_20210928_01_00.tif": 95058,
	"./nowcast/spi3/spi3_20210929_01_00.tif": 74181,
	"./nowcast/spi3/spi3_20210930_01_00.tif": 49631,
	"./nowcast/spi3/spi3_20211001_01_00.tif": 47533,
	"./nowcast/spi3/spi3_20211002_01_00.tif": 43815,
	"./nowcast/spi3/spi3_20211003_01_00.tif": 26298,
	"./nowcast/spi3/spi3_20211004_01_00.tif": 46785,
	"./nowcast/spi3/spi3_20211005_01_00.tif": 88880,
	"./nowcast/spi3/spi3_20211006_01_00.tif": 59273,
	"./nowcast/spi3/spi3_20211007_01_00.tif": 3781,
	"./nowcast/spi3/spi3_20211008_01_00.tif": 99536,
	"./nowcast/spi3/spi3_20211009_01_00.tif": 5726,
	"./nowcast/spi3/spi3_20211010_01_00.tif": 49735,
	"./nowcast/spi3/spi3_20211011_01_00.tif": 81339,
	"./nowcast/spi3/spi3_20211012_01_00.tif": 90408,
	"./nowcast/spi3/spi3_20211013_01_00.tif": 76552,
	"./nowcast/spi3/spi3_20211014_01_00.tif": 12467,
	"./nowcast/spi3/spi3_20211015_01_00.tif": 64489,
	"./nowcast/spi3/spi3_20211016_01_00.tif": 80681,
	"./nowcast/spi3/spi3_20211017_01_00.tif": 203,
	"./nowcast/spi3/spi3_20211018_01_00.tif": 34428,
	"./nowcast/spi3/spi3_20211019_01_00.tif": 385,
	"./nowcast/spi3/spi3_20211020_01_00.tif": 69529,
	"./nowcast/spi3/spi3_20211021_01_00.tif": 37696,
	"./nowcast/spi3/spi3_20211022_01_00.tif": 29413,
	"./nowcast/spi3/spi3_20211023_01_00.tif": 78378,
	"./nowcast/spi3/spi3_20211024_01_00.tif": 85607,
	"./nowcast/spi3/spi3_20211025_01_00.tif": 13503,
	"./nowcast/spi3/spi3_20211026_01_00.tif": 42954,
	"./nowcast/spi3/spi3_20211027_01_00.tif": 8009,
	"./nowcast/spi3/spi3_20211028_01_00.tif": 89970,
	"./nowcast/spi3/spi3_20211029_01_00.tif": 57677,
	"./nowcast/spi3/spi3_20211030_01_00.tif": 83340,
	"./nowcast/spi3/spi3_20211031_01_00.tif": 48861,
	"./nowcast/spi3/spi3_20211101_01_00.tif": 93979,
	"./nowcast/spi3/spi3_20211102_01_00.tif": 53160,
	"./nowcast/spi3/spi3_20211103_01_00.tif": 18069,
	"./nowcast/spi3/spi3_20211104_01_00.tif": 33292,
	"./nowcast/spi3/spi3_20211105_01_00.tif": 8134,
	"./nowcast/spi3/spi3_20211106_01_00.tif": 91467,
	"./nowcast/spi3/spi3_20211107_01_00.tif": 85293,
	"./nowcast/spi3/spi3_20211108_01_00.tif": 84990,
	"./nowcast/spi3/spi3_20211109_01_00.tif": 37349,
	"./nowcast/spi3/spi3_20211110_01_00.tif": 53344,
	"./nowcast/spi3/spi3_20211111_01_00.tif": 79255,
	"./nowcast/spi3/spi3_20211112_01_00.tif": 61040,
	"./nowcast/spi3/spi3_20211113_01_00.tif": 53341,
	"./nowcast/spi3/spi3_20211114_01_00.tif": 16,
	"./nowcast/spi3/spi3_20211115_01_00.tif": 63996,
	"./nowcast/spi3/spi3_20211116_01_00.tif": 22115,
	"./nowcast/spi3/spi3_20211117_01_00.tif": 92117,
	"./nowcast/spi3/spi3_20211118_01_00.tif": 11594,
	"./nowcast/spi3/spi3_20211119_01_00.tif": 14051,
	"./nowcast/spi3/spi3_20211120_01_00.tif": 94885,
	"./nowcast/spi3/spi3_20211121_01_00.tif": 41797,
	"./nowcast/spi3/spi3_20211122_01_00.tif": 33013,
	"./nowcast/spi3/spi3_20211123_01_00.tif": 86712,
	"./nowcast/spi3/spi3_20211124_01_00.tif": 18227,
	"./nowcast/spi3/spi3_20211125_01_00.tif": 97366,
	"./nowcast/spi3/spi3_20211126_01_00.tif": 85699,
	"./nowcast/spi3/spi3_20211127_01_00.tif": 17427,
	"./nowcast/spi3/spi3_20211128_01_00.tif": 41405,
	"./nowcast/spi3/spi3_20211129_01_00.tif": 40757,
	"./nowcast/spi3/spi3_20211130_01_00.tif": 51506,
	"./nowcast/spi3/spi3_20211201_01_00.tif": 15410,
	"./nowcast/spi3/spi3_20211202_01_00.tif": 16352,
	"./nowcast/spi3/spi3_20211203_01_00.tif": 50002,
	"./nowcast/spi3/spi3_20211204_01_00.tif": 14404,
	"./nowcast/spi3/spi3_20211205_01_00.tif": 13599,
	"./nowcast/spi3/spi3_20211206_01_00.tif": 61302,
	"./nowcast/spi3/spi3_20211207_01_00.tif": 58101,
	"./nowcast/spi3/spi3_20211208_01_00.tif": 3148,
	"./nowcast/spi3/spi3_20211209_01_00.tif": 40550,
	"./nowcast/spi3/spi3_20211210_01_00.tif": 82483,
	"./nowcast/spi3/spi3_20211211_01_00.tif": 31788,
	"./nowcast/spi3/spi3_20211212_01_00.tif": 67618,
	"./nowcast/spi3/spi3_20211213_01_00.tif": 28786,
	"./nowcast/spi3/spi3_20211214_01_00.tif": 11459,
	"./nowcast/spi3/spi3_20211215_01_00.tif": 54135,
	"./nowcast/spi3/spi3_20211216_01_00.tif": 8141,
	"./nowcast/spi3/spi3_20211217_01_00.tif": 91301,
	"./nowcast/spi3/spi3_20211218_01_00.tif": 47114,
	"./nowcast/spi3/spi3_20211219_01_00.tif": 17069,
	"./nowcast/spi3/spi3_20211220_01_00.tif": 93599,
	"./nowcast/spi3/spi3_20211221_01_00.tif": 71419,
	"./nowcast/spi3/spi3_20211222_01_00.tif": 51519,
	"./nowcast/spi3/spi3_20211223_01_00.tif": 26559,
	"./nowcast/spi3/spi3_20211224_01_00.tif": 852,
	"./nowcast/spi3/spi3_20211225_01_00.tif": 22924,
	"./nowcast/spi3/spi3_20211226_01_00.tif": 57434,
	"./nowcast/spi3/spi3_20211227_01_00.tif": 23458,
	"./nowcast/spi3/spi3_20211228_01_00.tif": 56482,
	"./nowcast/spi3/spi3_20211229_01_00.tif": 62852,
	"./nowcast/spi3/spi3_20211230_01_00.tif": 5434,
	"./nowcast/spi3/spi3_20211231_01_00.tif": 65046,
	"./nowcast/spi3/spi3_20220101_01_00.tif": 21327,
	"./nowcast/spi3/spi3_20220102_01_00.tif": 28559,
	"./nowcast/spi3/spi3_20220103_01_00.tif": 10649,
	"./nowcast/spi3/spi3_20220104_01_00.tif": 602,
	"./nowcast/spi3/spi3_20220105_01_00.tif": 26709,
	"./nowcast/spi3/spi3_20220106_01_00.tif": 93474,
	"./nowcast/spi3/spi3_20220107_01_00.tif": 91201,
	"./nowcast/spi3/spi3_20220108_01_00.tif": 15056,
	"./nowcast/spi3/spi3_20220109_01_00.tif": 90553,
	"./nowcast/spi3/spi3_20220110_01_00.tif": 9458,
	"./nowcast/spi3/spi3_20220111_01_00.tif": 71917,
	"./nowcast/spi3/spi3_20220112_01_00.tif": 44270,
	"./nowcast/spi3/spi3_20220113_01_00.tif": 63974,
	"./nowcast/spi3/spi3_20220114_01_00.tif": 23986,
	"./nowcast/spi3/spi3_20220115_01_00.tif": 52293,
	"./nowcast/spi3/spi3_20220116_01_00.tif": 22032,
	"./nowcast/spi3/spi3_20220117_01_00.tif": 44116,
	"./nowcast/spi3/spi3_20220118_01_00.tif": 49685,
	"./nowcast/spi3/spi3_20220119_01_00.tif": 44200,
	"./nowcast/spi3/spi3_20220120_01_00.tif": 57123,
	"./nowcast/spi3/spi3_20220121_01_00.tif": 71152,
	"./nowcast/spi3/spi3_20220122_01_00.tif": 83530,
	"./nowcast/spi3/spi3_20220123_01_00.tif": 57496,
	"./nowcast/spi3/spi3_20220124_01_00.tif": 15290,
	"./nowcast/spi3/spi3_20220125_01_00.tif": 45035,
	"./nowcast/spi3/spi3_20220126_01_00.tif": 70566,
	"./nowcast/spi3/spi3_20220127_01_00.tif": 90425,
	"./nowcast/spi3/spi3_20220128_01_00.tif": 20843,
	"./nowcast/spi3/spi3_20220129_01_00.tif": 52218,
	"./nowcast/spi3/spi3_20220130_01_00.tif": 23304,
	"./nowcast/spi3/spi3_20220131_01_00.tif": 71161,
	"./nowcast/spi3/spi3_20220201_01_00.tif": 31582,
	"./nowcast/spi3/spi3_20220202_01_00.tif": 94794,
	"./nowcast/spi3/spi3_20220203_01_00.tif": 85146,
	"./nowcast/spi3/spi3_20220204_01_00.tif": 35332,
	"./nowcast/spi3/spi3_20220205_01_00.tif": 97554,
	"./nowcast/spi3/spi3_20220206_01_00.tif": 38887,
	"./nowcast/spi3/spi3_20220207_01_00.tif": 31695,
	"./nowcast/spi3/spi3_20220208_01_00.tif": 5399,
	"./nowcast/spi3/spi3_20220209_01_00.tif": 97288,
	"./nowcast/spi3/spi3_20220210_01_00.tif": 39400,
	"./nowcast/spi3/spi3_20220211_01_00.tif": 22843,
	"./nowcast/spi3/spi3_20220212_01_00.tif": 54269,
	"./nowcast/spi3/spi3_20220213_01_00.tif": 94502,
	"./nowcast/spi3/spi3_20220214_01_00.tif": 55206,
	"./nowcast/spi3/spi3_20220215_01_00.tif": 24264,
	"./nowcast/spi3/spi3_20220216_01_00.tif": 6362,
	"./nowcast/spi3/spi3_20220217_01_00.tif": 55892,
	"./nowcast/spi3/spi3_20220218_01_00.tif": 89845,
	"./nowcast/spi3/spi3_20220219_01_00.tif": 71745,
	"./nowcast/spi3/spi3_20220220_01_00.tif": 14355,
	"./nowcast/spi3/spi3_20220221_01_00.tif": 94442,
	"./nowcast/spi3/spi3_20220222_01_00.tif": 19350,
	"./nowcast/spi3/spi3_20220223_01_00.tif": 57940,
	"./nowcast/spi3/spi3_20220224_01_00.tif": 36687,
	"./nowcast/spi3/spi3_20220225_01_00.tif": 93542,
	"./nowcast/spi3/spi3_20220226_01_00.tif": 72735,
	"./nowcast/spi3/spi3_20220227_01_00.tif": 76461,
	"./nowcast/spi3/spi3_20220228_01_00.tif": 65111,
	"./nowcast/spi3/spi3_20220301_01_00.tif": 45889,
	"./nowcast/spi3/spi3_20220302_01_00.tif": 51799,
	"./nowcast/spi3/spi3_20220303_01_00.tif": 21918,
	"./nowcast/spi3/spi3_20220304_01_00.tif": 96845,
	"./nowcast/spi3/spi3_20220305_01_00.tif": 27212,
	"./nowcast/spi3/spi3_20220306_01_00.tif": 66761,
	"./nowcast/spi3/spi3_20220307_01_00.tif": 3636,
	"./nowcast/spi3/spi3_20220308_01_00.tif": 66594,
	"./nowcast/spi3/spi3_20220309_01_00.tif": 99960,
	"./nowcast/spi3/spi3_20220310_01_00.tif": 18140,
	"./nowcast/spi3/spi3_20220311_01_00.tif": 39664,
	"./nowcast/spi3/spi3_20220312_01_00.tif": 54259,
	"./nowcast/spi3/spi3_20220313_01_00.tif": 34992,
	"./nowcast/spi3/spi3_20220314_01_00.tif": 4511,
	"./nowcast/spi3/spi3_20220315_01_00.tif": 99453,
	"./nowcast/spi3/spi3_20220316_01_00.tif": 22170,
	"./nowcast/spi3/spi3_20220317_01_00.tif": 98773,
	"./nowcast/spi3/spi3_20220318_01_00.tif": 56658,
	"./nowcast/spi3/spi3_20220319_01_00.tif": 96032,
	"./nowcast/spi3/spi3_20220320_01_00.tif": 71555,
	"./nowcast/spi3/spi3_20220321_01_00.tif": 99255,
	"./nowcast/spi3/spi3_20220322_01_00.tif": 25412,
	"./nowcast/spi3/spi3_20220323_01_00.tif": 62401,
	"./nowcast/spi3/spi3_20220324_01_00.tif": 9394,
	"./nowcast/spi3/spi3_20220325_01_00.tif": 15084,
	"./nowcast/spi3/spi3_20220326_01_00.tif": 63226,
	"./nowcast/spi3/spi3_20220327_01_00.tif": 17876,
	"./nowcast/spi3/spi3_20220328_01_00.tif": 63797,
	"./nowcast/spi3/spi3_20220329_01_00.tif": 47786,
	"./nowcast/spi3/spi3_20220330_01_00.tif": 38519,
	"./nowcast/spi3/spi3_20220331_01_00.tif": 81316,
	"./nowcast/spi3/spi3_20220401_01_00.tif": 50620,
	"./nowcast/spi3/spi3_20220402_01_00.tif": 12901,
	"./nowcast/spi3/spi3_20220403_01_00.tif": 53503,
	"./nowcast/spi3/spi3_20220404_01_00.tif": 24980,
	"./nowcast/spi3/spi3_20220405_01_00.tif": 54855,
	"./nowcast/spi3/spi3_20220406_01_00.tif": 90193,
	"./nowcast/spi3/spi3_20220407_01_00.tif": 51933,
	"./nowcast/spi3/spi3_20220408_01_00.tif": 9409,
	"./nowcast/spi3/spi3_20220409_01_00.tif": 17969,
	"./nowcast/spi3/spi3_20220410_01_00.tif": 96575,
	"./nowcast/spi3/spi3_20220411_01_00.tif": 37735,
	"./nowcast/spi3/spi3_20220412_01_00.tif": 32956,
	"./nowcast/spi3/spi3_20220413_01_00.tif": 31543,
	"./nowcast/spi3/spi3_20220414_01_00.tif": 48847,
	"./nowcast/spi3/spi3_20220415_01_00.tif": 7863,
	"./nowcast/spi3/spi3_20220416_01_00.tif": 80890,
	"./nowcast/spi3/spi3_20220417_01_00.tif": 179,
	"./nowcast/spi3/spi3_20220418_01_00.tif": 88633,
	"./nowcast/spi3/spi3_20220419_01_00.tif": 97691,
	"./nowcast/spi3/spi3_20220420_01_00.tif": 36627,
	"./nowcast/spi3/spi3_20220421_01_00.tif": 87130,
	"./nowcast/spi3/spi3_20220422_01_00.tif": 79073,
	"./nowcast/spi3/spi3_20220423_01_00.tif": 3454,
	"./nowcast/spi3/spi3_20220424_01_00.tif": 38803,
	"./nowcast/spi3/spi3_20220425_01_00.tif": 68904,
	"./nowcast/spi3/spi3_20220426_01_00.tif": 30209,
	"./nowcast/spi3/spi3_20220427_01_00.tif": 7388,
	"./nowcast/spi3/spi3_20220428_01_00.tif": 59953,
	"./nowcast/spi3/spi3_20220429_01_00.tif": 95836,
	"./nowcast/spi3/spi3_20220430_01_00.tif": 39103,
	"./nowcast/spi3/spi3_20220501_01_00.tif": 55869,
	"./nowcast/spi3/spi3_20220502_01_00.tif": 78649,
	"./nowcast/spi3/spi3_20220503_01_00.tif": 86,
	"./nowcast/spi3/spi3_20220504_01_00.tif": 94208,
	"./nowcast/spi3/spi3_20220505_01_00.tif": 94721,
	"./nowcast/spi3/spi3_20220506_01_00.tif": 39876,
	"./nowcast/spi3/spi3_20220507_01_00.tif": 15847,
	"./nowcast/spi3/spi3_20220508_01_00.tif": 70875,
	"./nowcast/spi3/spi3_20220509_01_00.tif": 88412,
	"./nowcast/spi3/spi3_20220510_01_00.tif": 57075,
	"./nowcast/spi3/spi3_20220511_01_00.tif": 70507,
	"./nowcast/spi3/spi3_20220512_01_00.tif": 91430,
	"./nowcast/spi3/spi3_20220513_01_00.tif": 38880,
	"./nowcast/spi3/spi3_20220514_01_00.tif": 34040,
	"./nowcast/spi3/spi3_20220515_01_00.tif": 29066,
	"./nowcast/spi3/spi3_20220516_01_00.tif": 95119,
	"./nowcast/spi3/spi3_20220517_01_00.tif": 64146,
	"./nowcast/spi3/spi3_20220518_01_00.tif": 10279,
	"./nowcast/spi3/spi3_20220519_01_00.tif": 26652,
	"./nowcast/spi3/spi3_20220520_01_00.tif": 80125,
	"./nowcast/spi3/spi3_20220521_01_00.tif": 61387,
	"./nowcast/spi3/spi3_20220522_01_00.tif": 29654,
	"./nowcast/spi3/spi3_20220523_01_00.tif": 5919,
	"./nowcast/spi3/spi3_20220524_01_00.tif": 3445,
	"./nowcast/spi3/spi3_20220525_01_00.tif": 27047,
	"./nowcast/spi3/spi3_20220526_01_00.tif": 70136,
	"./nowcast/spi3/spi3_20220527_01_00.tif": 94048,
	"./nowcast/spi3/spi3_20220528_01_00.tif": 51333,
	"./nowcast/spi3/spi3_20220529_01_00.tif": 37843,
	"./nowcast/spi3/spi3_20220530_01_00.tif": 2450,
	"./nowcast/spi3/spi3_20220531_01_00.tif": 26615,
	"./nowcast/spi3/spi3_20220601_01_00.tif": 43557,
	"./nowcast/spi3/spi3_20220602_01_00.tif": 10861,
	"./nowcast/spi3/spi3_20220603_01_00.tif": 9803,
	"./nowcast/spi3/spi3_20220604_01_00.tif": 35119,
	"./nowcast/spi3/spi3_20220605_01_00.tif": 68274,
	"./nowcast/spi3/spi3_20220606_01_00.tif": 70862,
	"./nowcast/spi3/spi3_20220607_01_00.tif": 21781,
	"./nowcast/spi3/spi3_20220608_01_00.tif": 50645,
	"./nowcast/spi3/spi3_20220609_01_00.tif": 62438,
	"./nowcast/spi3/spi3_20220610_01_00.tif": 76140,
	"./nowcast/spi3/spi3_20220611_01_00.tif": 86393,
	"./nowcast/spi3/spi3_20220612_01_00.tif": 98379,
	"./nowcast/spi3/spi3_20220613_01_00.tif": 5659,
	"./nowcast/spi3/spi3_20220614_01_00.tif": 62846,
	"./nowcast/spi3/spi3_20220615_01_00.tif": 71968,
	"./nowcast/spi3/spi3_20220616_01_00.tif": 17038,
	"./nowcast/spi3/spi3_20220617_01_00.tif": 95349,
	"./nowcast/spi3/spi3_20220618_01_00.tif": 76852,
	"./nowcast/spi3/spi3_20220619_01_00.tif": 80487,
	"./nowcast/spi3/spi3_20220620_01_00.tif": 18287,
	"./nowcast/spi3/spi3_20220621_01_00.tif": 67689,
	"./nowcast/spi3/spi3_20220622_01_00.tif": 95253,
	"./nowcast/spi3/spi3_20220623_01_00.tif": 55596,
	"./nowcast/spi3/spi3_20220624_01_00.tif": 1502,
	"./nowcast/spi3/spi3_20220625_01_00.tif": 90077,
	"./nowcast/spi3/spi3_20220626_01_00.tif": 73116,
	"./nowcast/spi3/spi3_20220627_01_00.tif": 88322,
	"./nowcast/spi3/spi3_20220628_01_00.tif": 35283,
	"./nowcast/spi3/spi3_20220629_01_00.tif": 51135,
	"./nowcast/spi3/spi3_20220630_01_00.tif": 39719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43164;